import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { loadBuildInfo } from '@app/core/store/app-context/app-context.actions';
import { selectBuildInfoLoaded } from '@app/core/store/app-context/app-context.selectors';
import { filter, first, tap } from 'rxjs';

export const buildInfoResolver: ResolveFn<boolean> = () => {
  const store = inject(Store);

  return store.select(selectBuildInfoLoaded).pipe(
    tap(loaded => {
      if (!loaded) {
        store.dispatch(loadBuildInfo());
      }
    }),
    filter(loaded => loaded),
    first()
  );
};
